(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlCurrency', ['Currency'])
        .directive('dynamicCurrency', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-currency/custom-control-currency-template.html'
            };
        });

    angular.module('CustomControlCurrency')
       .directive('dynamicFilterCurrency', ['$translate', function () {
           return {
               replace: true,
               restrict: 'E',
               controller: ['$scope', function ($scope) {                
               }],
               templateUrl: '/app/directives/custom-control-currency/custom-control-filter-currency-template.html'
           };
       }]);
})();